<template>
    <el-container class="design-container" v-loading="second" :element-loading-text="`效果图制作中${second}秒`"
        element-loading-background="rgba(255,255,255,1)">
        <el-main class="design-content">
            <div id="status" style="position: fixed; top: 0; left: 0" v-if="statusMsg">
                {{ statusMsg }}
            </div>
            <!-- <div class="content--left"></div> -->
            <div id="workspace" class="content--center">
                <div class="editor-canvas" v-if="designFaceData.length > 0">
                    <div class="editor-canvas-bg" :style="{
                        width: canvasW * zoomScale + 'px',
                        height: canvasH * zoomScale + 'px',
                    }"></div>
                    <fabric-editor v-for="(item, index) in designFaceData" v-show="index == faceIndex" :key="index"
                        :index="index" :value="item" :width="canvasW" :height="canvasH" :left="designFaceShiftX"
                        :top="designFaceShiftY" ref="editor" @zoomChange="handleZoomChange"
                        @confirm="setCanvas(index)"></fabric-editor>
                </div>
            </div>
            <div class="content--right" style="position: absolute; right: 0">
                <div class="design-effect">
                    <div class="effect-preview">
                        <el-carousel :height="600 + 'px'" arrow="always" :autoplay="false" trigger="click">
                            <el-carousel-item v-for="(item, index) in effectData" :key="index">
                                <effect ref="effectRef" :value="item" :imgLayer="currentSpecName && item.imgLayer?.[currentSpecName]
                                    ? item.imgLayer?.[currentSpecName]
                                    : 1
                                    " :modelUrl="currentSpecName && item.model_url?.[currentSpecName]
                                        ? item.model_url?.[currentSpecName]
                                        : []
                                        " :id="index" :type="2" :images="currentSpecName && item.images?.[currentSpecName]
                                            ? item.images?.[currentSpecName]
                                            : []
                                            " :modelParams="modelParams"></effect>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
        </el-main>
    </el-container>
</template>
<script>
import FabricEditor from "./components/fabric-editor.vue";
import Effect from "./components/effect.vue";
import OSS from "@/utils/oss.js";
import md5 from "js-md5";
import {
    otherGetRequest,
    otherPostRequest,
    deepClone,
    getRandomString,
} from "@/utils/util.ts";
// 创建Web Worker
const createWorker = () => {
    const workerCode = `
                self.addEventListener('message', async function (e) {
    const { task, canvasWidth, canvasHeight,name } = e.data;
    const arrayOfImageElements = await getAllImage(task.images.filter(item=> item !== ''));
    let canvas = new OffscreenCanvas(canvasWidth, canvasHeight);
    let ctx = canvas.getContext('2d');
    if (task.img_suffix != "image/png") {
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, canvasWidth, canvasHeight);
    }
    for (let img of arrayOfImageElements) {
      await drawImage(ctx, img, canvasWidth, canvasHeight)
    }
      
    canvas.convertToBlob({ type: task.img_suffix }).then((blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        return new Promise(resolve => {
            reader.onloadend = () => {
                resolve(reader.result);
            };
        });
    }).then((base64) => {
        // 把取到的base64 传给主线程
        self.postMessage({ ...task,...{image:base64,type:'completed'}} )
    })
});

function drawImage(ctx, imageObj, width, height) {
    return new Promise((resolve, reject) => {
        self.createImageBitmap(imageObj)
            .then((imageBitmap) => {
                ctx.drawImage(imageBitmap, 0, 0, width, height);
                resolve(true)
            });
    })
}

async function getAllImage(images) {
    const imgUrls = images;
    let arrayOfImages = [];
    await Promise.all(imgUrls.map(loadImageAsync))
        .then(arrayOfImageElements => {
            arrayOfImages = arrayOfImageElements;
        });
    return arrayOfImages;
}

function loadImageAsync(imageUrl) {
    return new Promise((resolve, reject) => {
        fetch(imageUrl)
            .then((response) => {
                return response.blob();
            }).then((blob) => {
                resolve(blob);
            });

    });
}
            `;
    const blob = new Blob([workerCode], { type: 'application/javascript' });
    return new Worker(URL.createObjectURL(blob));
};
export default {
    components: {
        FabricEditor,
        Effect,
    },

    data() {
        return {
            workers: null,
            workerCounts: 5,
            workerTask: [],
            tempImages: [],
            statusMsg: "",
            id: 0,
            timer: null,
            second: 0,
            workspaceWidth: 0,
            workspaceHeight: 0,
            designFaceShiftX: 0,
            designFaceShiftY: 0,
            canvasW: 650,
            canvasH: 650,
            zoomScale: 1,
            canvasArr: [],
            fabricCanvas: null,
            editor: null,
            effectRef: null,
            productInfo: {},
            faceIndex: 0,
            faceName: "",
            currentFace: {},
            designFaceData: [],
            effectData: [{}],
            currentSpecName: "",
            modelParams: {},
            design_url: "",
            ossClass: null,
            target_type: 1,
            fontList: [],
            attrDesigns: [],
            model: null,
            task: {},
            defaultEffect: [],
            uniqueObj: [],
            colorTempImgs: []
        };
    },
    watch: {
        faceIndex: {
            handler(val) {
                this.editor = this.$refs.editor[val];
                this.fabricCanvas = this.$refs.editor[val].canvas;
                this.currentFace = this.designFaceData[val];
                this.faceName = this.designFaceData[val].design_name;
            },
        },
    },
    methods: {
        setCanvas(index) {
            if (index == 0) {
                this.faceIndex = index;
            }
        },
        handleZoomChange(value) {
            const workspaceElement = document.getElementById("workspace");
            this.zoomScale = value;
            if (workspaceElement) {
                this.designFaceShiftX =
                    (workspaceElement.offsetWidth - this.canvasW * value) / 2;
                this.designFaceShiftY =
                    (workspaceElement.offsetHeight - this.canvasH * value) / 2;
            }
        },

        async refreshTexture(faceIndex = null, faceName = "", effectIndex = null) {
            return new Promise(async (resolve, reject) => {
                const canvas = this.$refs.editor[faceIndex].canvas;
                const designName = faceName;
                let defaultBgColor = null;
                let defaultTexture = null;
                canvas.overlayImage = null;
                // 使用默认底色
                if (!canvas.backgroundColor && this.currentFace.bg_color) {
                    defaultBgColor = this.currentFace.bg_color;
                }
                if (defaultBgColor) {
                    canvas.setBackgroundColor(
                        defaultBgColor,
                        canvas.renderAll.bind(canvas)
                    );
                }

                // 使用默认贴图
                if (this.currentFace.texture && this.currentFace.reserve_texture) {
                    defaultTexture = this.currentFace.texture;
                    await this.setDefaultTexture(defaultTexture);
                }
                const scale = 1600;
                const texture = canvas.toDataURL({
                    left: this.designFaceShiftX,
                    top: this.designFaceShiftY,
                    width: this.canvasW * this.zoomScale,
                    height: this.canvasH * this.zoomScale,
                    multiplier: scale / (this.canvasW * this.zoomScale),
                    format: "png",
                });
                setTimeout(async () => {
                    if (effectIndex === null) {
                        for (let index in this.effectData) {
                            let effect = this.effectData[index];
                            let is_diy = this.$refs.effectRef[index]["modelUrl"].find(
                                (item) => item.url != ""
                            );
                            if (is_diy) {
                                let bigimg = await this.$refs.effectRef[index].setMapTexture({
                                    name: designName,
                                    url: texture,
                                    remove_color: defaultBgColor,
                                });
                                if (bigimg !== true) {
                                    this.$set(effect, "bigimg", bigimg);
                                }
                            }
                        }
                        resolve(true);
                    } else {
                        let effect = this.effectData[0];
                        if (effect.is_diy) {
                            let bigimg = await this.$refs.effectRef[
                                effectIndex
                            ].setMapTexture({
                                name: designName,
                                url: texture,
                                remove_color: defaultBgColor,
                            });
                            if (bigimg !== true) {
                                resolve(bigimg);
                            } else {
                                resolve("");
                            }
                        }
                    }
                }, 300);
            });
        },
        setDefaultTexture(texture) {
            return new Promise((resolve, reject) => {
                fabric.Image.fromURL(
                    texture,
                    (img) => {
                        this.fabricCanvas.setBackgroundImage(
                            img,
                            this.fabricCanvas.renderAll.bind(this.fabricCanvas),
                            {
                                scaleX: this.canvasW / img.width,
                                scaleY: this.canvasH / img.height,
                            }
                        );
                        resolve(true);
                    },
                    { crossOrigin: "anonymous" }
                );
            });
        },
        //属性
        restoreAttr() {
            return new Promise((resolve, reject) => {
                if (this.attrDesigns && this.attrDesigns.length > 0) {
                    for (let attr of this.attrDesigns) {
                        let parts = deepClone(attr.value.parts);
                        switch (attr.type) {
                            case 1:
                                for (let index in this.effectData) {
                                    for (let part of parts) {
                                        this.$refs.effectRef[index].setModelColor({
                                            name: part,
                                            color: attr.value.value.color,
                                        });
                                    }
                                }
                                break;
                            case 2:
                                for (let index in this.effectData) {
                                    for (let part of parts) {
                                        this.$refs.effectRef[index].setModelColor({
                                            name: part,
                                            color: attr.value.value.color,
                                        });
                                    }
                                }
                                break;
                            case 3:
                                for (let index in this.effectData) {
                                    for (let part of parts) {
                                        this.$refs.effectRef[index].setNormalMap({
                                            name: part,
                                            img: attr.value.value.image,
                                            repeat: attr.value.value.normalmapRepeat,
                                            scale: attr.value.value.normalmapScale,
                                        });
                                    }
                                }
                                break;
                            case 4:
                                break;
                            case 5:
                                for (let index in this.effectData) {
                                    for (let part of parts) {
                                        this.$refs.effectRef[index].setMapTexture({
                                            name: part,
                                            url: attr.value.value.image,
                                        });
                                    }
                                }
                                break;
                            case 6:
                                for (let index in this.effectData) {
                                    this.$refs.effectRef[index].switchModelByName({
                                        parts: parts,
                                        model_url: attr.value.value.model_url[index],
                                    });
                                }
                                break;
                        }
                    }
                    resolve(true);
                } else {
                    resolve(true);
                }
            });
        },







        setError(err) {
            this.statusMsg = "error";
            this.$message.error(err);
        },

        //
        async buildEffectImages() {
            try {
                const tasks = {}
                const colorObj = {}
                this.productInfo.spec_value?.[0]?.spec_list.forEach(item => {
                    colorObj[item.value] = item.color
                })
                const spec_value_list = this.productInfo.spec_value_list.map(item => item.spec_value_str)
                for (let [key, value] of this.effectData.entries()) {
                    this.uniqueObj[key] = {}
                    this.colorTempImgs[key] = {}
                    const is_differ = value.is_differ
                    const img_suffix = value.img_suffix
                    const keys = Object.keys(value.images)
                    for (let k of keys) {
                        if (!spec_value_list.includes(k)) {
                            continue
                        }
                        let effectRef = this.$refs.effectRef[key]
                        let images = deepClone(value.images[k])
                        const img_layer = value.more_spec == 1 ? value.imgLayer[k] : value.img_layer
                        const model_url = value.more_spec == 1 ? value.model_url[k] : value.model_url
                        let is_diy = effectRef["modelUrl"].find(
                            (item) => item.url != ""
                        );
                        if (is_diy) {
                            let texture = ''
                            const spec = this.productInfo.spec_value_list.find(item => item.spec_value_str === k)
                            if (spec.bind_action == 1 && spec.bind_parts) {
                                const colorName = k.split(',')[0]
                                if (this.colorTempImgs[key][colorName]) {
                                    texture = this.colorTempImgs[key][colorName]
                                } else {
                                    const color = colorObj[colorName]
                                    const parts = spec.bind_parts.split(",")?.filter(part => part.trim() !== '')
                                    await effectRef.setModelColorMutlipe({
                                        parts,
                                        color: color,
                                    })
                                    texture = await effectRef.getModelImage()
                                    this.colorTempImgs[key][colorName] = texture
                                }
                            } else if (is_differ) {
                                console.log(model_url, k)
                                await effectRef.switchModel({
                                    fileParams: model_url,
                                })
                                const promises = [];
                                for (let index in this.designFaceData) {
                                    const name = this.designFaceData[index].design_name;
                                    promises.push(this.refreshTexture(index, name, key));
                                }
                                await Promise.all(promises);
                                texture = await effectRef.getModelImage()
                            } else {
                                texture = await effectRef.getModelImage()
                            }
                            if (texture != '') {
                                images.splice(img_layer, 0, texture)
                            }
                        }
                        const unique = md5(JSON.stringify(images) + JSON.stringify(model_url) + `effect-${key}`)
                        this.uniqueObj[key][k] = unique
                        if (!tasks[unique]) {
                            tasks[unique] = { key: unique, images: images, name: k, effectIndex: key, img_suffix: `image/${img_suffix == "png" ? "png" : "jpeg"}`, status: 'pending' }
                        }
                    }
                }
                this.workerTask = Object.values(tasks)
                this.nextWorkerTask()
            } catch (err) {
                console.log(err)
                this.setError(err);
            }
        },


        loadOldDesignDatas() {
            return new Promise((resolve, reject) => {
                fetch(this.design_url)
                    .then((response) => response.json())
                    .then((res) => {
                        resolve(res.design);
                    });
            });
        },

        async initEffectModel() {
            try {
                const promises = [];
                for (const i in this.effectData) {
                    if (this.effectData[i].is_diy) {
                        promises.push(this.$refs.effectRef[i].init());
                    }
                }
                await Promise.all(promises);
            } catch (e) {
                console.log(e);
                throw e;
            }
        },

        async createDesignDatas(value) {
            try {
                const promises = [];
                for (let index in value) {
                    let canvas = this.$refs.editor[index].canvas;
                    let json = value[index];
                    promises.push(this.loadFromJSON(canvas, json, index));
                    await Promise.all(promises);
                }
            } catch (e) {
                console.log(e);
                throw e;
            }
        },
        loadFromJSON(canvas, json, index) {
            return new Promise(async (resolve, reject) => {
                canvas.loadFromJSON(json, async () => {
                    canvas.renderAll();
                    let repeat = canvas
                        .getObjects()
                        .find((item) => item.type == "image" && item.extraData.repeat.show);
                    if (repeat) {
                        await this.$refs.editor[index].changeRepeat(
                            repeat,
                            repeat.extraData.repeat
                        );
                    }
                    setTimeout(() => {
                        resolve(true);
                    }, 200);
                });
            });
        },


        async loadFont(value) {
            try {
                if (value.name === "Tiff-Heavy") {
                    value.url =
                        "https://fqpod.oss-cn-guangzhou.aliyuncs.com/uploads/fonts/20250707/35g685ip2h.woff2";
                }
                const font = new FontFace(value.name, `url(${value.url})`);
                const loadedFont = await font.load();
                document.fonts.add(loadedFont);
                return value.name;
            } catch (err) {
                console.error("加载字体失败:", err);
                throw err;
            }
        },
        async getCustomEffect() {
            try {
                const res = await fetch(this.design_url)
                const data = await res.json()
                if (data.defaultEffect && data.defaultEffect.length > 0) {
                    for (let item of data.defaultEffect) {
                        let i = item.num
                        let images = this.productInfo.design_effects[i]['images'].split(',')
                        images[0] = item.bg_img
                        this.productInfo.design_effects[i]['images'] = images.join(',')
                    }
                }
                return
            } catch (error) {

            }
        },
        createDesignFaces(designFaceList) {
            return new Promise((resolve, reject) => {
                const faceData = [];
                const modelParams = {};
                for (const index in designFaceList) {
                    const face = designFaceList[index];
                    let cloneData = deepClone(face);
                    if ([1, 3].indexOf(face.is_diy) > -1) {
                        if (cloneData.more_spec == 1) {
                            let sku_diy_data = JSON.parse(deepClone(cloneData.sku_diy_data));
                            let currentData = sku_diy_data.find(
                                (item) => item.name == this.currentSpecName
                            );
                            cloneData = { ...cloneData, ...currentData };
                        }
                        const {
                            design_size,
                            production_size,
                            recommend_size,
                            crop_size,
                            dotted_size,
                        } = cloneData;
                        const designSize = design_size.split("|");
                        cloneData.maxwidth = designSize[0];
                        cloneData.maxheight = designSize[1];
                        const productionSize = production_size.split("|");
                        cloneData.productionWidth = productionSize[0];
                        cloneData.productionHeight = productionSize[1];
                        const dottedSize = dotted_size.split("|");
                        cloneData.dottedWidth = dottedSize[0];
                        cloneData.dottedHeight = dottedSize[1];
                        cloneData.crop_size = crop_size.split("|");
                        cloneData.printquality = "";
                        cloneData.recommend_size = recommend_size
                            ? recommend_size.split("x").map(Number)
                            : ["", ""];
                        cloneData.design_full = 0; //1未铺满2已铺满
                        faceData.push(cloneData);
                        const modelData = deepClone(face);
                        if (modelData.normalmap) {
                            const normalmap = JSON.parse(modelData.normalmap);
                            modelData.normalMap = {
                                img: normalmap.img,
                                repeat: normalmap.repeat,
                                scale: normalmap.scale,
                            };
                        } else {
                            modelData.normalMap = null;
                        }
                        modelData.default_texture = modelData.texture;
                        modelParams[face.design_name] = modelData;
                    } else {
                        if (cloneData.normalmap) {
                            const normalmap = JSON.parse(cloneData.normalmap);
                            cloneData.normalMap = {
                                img: normalmap.img,
                                repeat: normalmap.repeat,
                                scale: normalmap.scale,
                            };
                        } else {
                            cloneData.normalMap = null;
                        }
                        modelParams[face.design_name] = cloneData;
                    }
                }
                this.designFaceData = faceData;
                this.modelParams = modelParams;
                resolve(true);
            });
        },

        createEffectDatas(effectRes) {
            return new Promise((resolve, reject) => {
                let effectArr = [];
                if (effectRes.length > 0) {
                    for (const i in effectRes) {
                        const item = deepClone(effectRes[i]);
                        let images = {};
                        let model_url = {};
                        let imgLayer = {};
                        if (item.more_spec == 1) {
                            for (let skuData of JSON.parse(deepClone(item.sku_diy_data))) {
                                images[skuData.name] = skuData.images;
                                model_url[skuData.name] = skuData.model;
                                imgLayer[skuData.name] = Number(skuData.img_layer);
                            }
                        } else {
                            let imageTemp = deepClone(item.images)
                                ? deepClone(item.images).split(",")
                                : [];
                            for (let spec of this.productInfo.spec_value_list) {
                                images[spec.spec_value_str] = imageTemp;
                                model_url[spec.spec_value_str] = JSON.parse(item.model_url);
                                imgLayer[spec.spec_value_str] = Number(item.img_layer);
                            }
                        }
                        item.images = images;
                        item.model_url = model_url;
                        item.imgLayer = imgLayer;
                        item.currentImgs = images[this.currentSpecName];
                        item.currentImgIndex = imgLayer[this.currentSpecName];
                        item.preview_img = "";
                        item.preview_loaded = false;
                        item.model_json = "";
                        effectArr.push(item);
                    }
                    this.effectData = effectArr;
                }
                resolve(true);
            });
        },


        async handleSave(tempImages) {
            try {
                const tasks = deepClone(tempImages)
                const promises = []
                for (let task of tasks) {
                    promises.push(this.ossClass.putb64ToOss({
                        content: task.image,
                        type: "effect",
                    }))
                }
                let ossRes = await Promise.all(promises)
                for (let index in ossRes) {
                    tasks[index].image = ossRes[index]
                }
                const getImg = (sku) => {
                    const images = []
                    for (let index in this.effectData) {
                        const key = this.uniqueObj[index][sku.spec_value_str]
                        const effect = tasks.filter(item => item.effectIndex == index)
                        let is_exits = effect.find(item => item.key == key)?.image
                        images.push(is_exits)
                    }
                    return images
                }
                let sku_list = []
                let currentSkuImages = []
                for (let skuIndex in this.productInfo.spec_value_list) {
                    let sku = this.productInfo.spec_value_list[skuIndex];
                    const images = getImg(sku)
                    if (this.currentSpecName == sku.spec_value_str) {
                        currentSkuImages = images
                    }
                    console.log(sku.spec_value_str, images)
                    sku_list.push({
                        id: sku.id + "",
                        item_id: sku.id + "",
                        model_item_id: sku.model_item_id + "",
                        images: images,

                    });
                }
                let params = {
                    id: this.id,
                    images: currentSkuImages,
                    sku_list: sku_list,
                    is_master: this.task.is_master.toString(),
                };
                otherPostRequest("/goods.goodsDesignTask/syncTaskResultV2", params, {
                    sign: md5(
                        JSON.stringify(params) + "332994CF-622B-44FB-82DD-C11B1FFD95B5"
                    ),
                }).then((res) => {
                    setTimeout(() => {
                        if (typeof res == "string") {
                            this.setError("error");
                        } else {
                            clearInterval(this.timer);
                            this.statusMsg = "success";
                            if (this.$route.query.auto && this.$route.query.auto == 0) {
                                window.close();
                            }
                        }
                    }, 200);
                });
            } catch (e) {
                console.log("🚀 ~ handleSave:", e)
            }
        },

        initWorkers() {
            let that = this
            async function handleWorkerMessage(e) {
                this.busy = false
                let taskIndex = that.workerTask.findIndex(item => item.key === e.data.key)
                if (e.data.type === 'completed') {
                    that.tempImages.push({
                        key: e.data.key,
                        image: e.data.image,
                        name: e.data.name,
                        effectIndex: e.data.effectIndex
                    })
                }
                if (that.workerTask.length === that.tempImages.length) {
                    that.handleSave(that.tempImages)
                } else {
                    that.nextWorkerTask()
                }
            }
            const workers = []
            for (let i = 0; i < this.workerCounts; i++) {
                const worker = createWorker()
                worker.onmessage = handleWorkerMessage
                workers.push(worker)
            }
            this.workers = workers
        },

        nextWorkerTask() {
            // 查找待处理的任务
            const pendingTasks = this.workerTask.filter(task => task.status === 'pending');
            if (pendingTasks.length === 0) {
                return;
            }
            // 查找空闲Worker
            const idleWorkers = this.workers.filter(worker => !worker.busy);
            if (idleWorkers.length === 0) {
                return;
            }
            // 分配任务给空闲Worker
            const assignments = Math.min(pendingTasks.length, idleWorkers.length);
            for (let i = 0; i < assignments; i++) {
                const task = pendingTasks[i];
                const worker = idleWorkers[i];
                worker.busy = true;
                task.status = 'processing';
                worker.postMessage({
                    canvasWidth: 1600,
                    canvasHeight: 1600,
                    task
                });
            }
        }

    },

    async mounted() {
        // 创建Web Worker
        this.initWorkers()
        const toast = this.$message({
            message: "正在还原设计内容...",
            center: true,
            type: "success",
        });

        const workspaceElement = document.getElementById("workspace");
        if (workspaceElement) {
            this.workspaceWidth = workspaceElement.offsetWidth;
            this.workspaceHeight = workspaceElement.offsetHeight;
        }
        let params = { id: this.$route.query.id };
        otherGetRequest(`/goods.goodsDesignTask/getTaskDetail`, params, {
            sign: md5(
                JSON.stringify(params) + "332994CF-622B-44FB-82DD-C11B1FFD95B5"
            ),
        })
            .then(async (res) => {
                if (typeof res === "string") {
                    this.setError("error");
                }
                this.statusMsg = "1";
                this.timer = setInterval(async () => {
                    this.second += 1;
                    if (this.second >= 120) {
                        this.setError("error");
                    }
                }, 1000);
                this.id = params.id;
                this.model = res.model;
                this.design_url = res.design.design_url;
                this.currentSpecName = res.task.spec_value_str;
                this.fontList = res.task.fonts;
                if (this.fontList.length > 0) {
                    const promises = [];
                    for (let font of this.fontList) {
                        promises.push(this.loadFont(font));
                    }
                    await Promise.all(promises);
                }
                this.productInfo = res.model;
                this.target_type = res.task.target_type;
                if (this.model.model.spec_all_chose == 0) {
                    this.productInfo.spec_value_list =
                        this.productInfo.spec_value_list.filter((item) => {
                            return item.spec_value_str == this.currentSpecName;
                        });
                }
                this.task = res.task;
                if (this.target_type == 3) {
                    this.task.is_all = 1;
                    this.task.is_master = 1;
                }
                this.ossClass = new OSS(res.sts_token);
                await this.getCustomEffect();
                //初始定制数据
                await Promise.all([
                    this.createDesignFaces(this.productInfo.design_parts),
                    this.createEffectDatas(this.productInfo.design_effects),
                ]);
                //初始效果图模型读取定制JSON
                let result = await Promise.all([
                    this.initEffectModel(),
                    this.loadOldDesignDatas(this.design_url),
                ]);
                let designDatas = result[1];
                this.editor = this.$refs.editor[0];
                this.fabricCanvas = this.$refs.editor[0].canvas;
                this.currentFace = this.designFaceData[0];
                this.faceName = this.designFaceData[0].design_name;
                //加载属性
                await this.restoreAttr();
                //恢复定制面数据
                await this.createDesignDatas(designDatas);
                const promises = [];
                for (let index in this.designFaceData) {
                    this.faceIndex = index;
                    const name = this.designFaceData[index].design_name;
                    promises.push(this.refreshTexture(index, name));
                }
                await Promise.all(promises);
                setTimeout(async () => {
                    this.buildEffectImages();
                    toast.close();
                }, 200);
            })
            .catch((err) => {
                this.setError(err);
            });
    },
};
</script>
